<main>
  <span role="button" (click)="navigateBackToOverview()"
    > <img
    src="/assets/img/mobile/arrow-left.svg"
    alt="close icon"
    class="left-arrow"
    width="8"
    height="17"
    /> Back to entry overview</span
    >

    <h1>3D view - {{ entryData().uniprotDescription?.slice(0, 10) }}...</h1>

    <section class="chips">
      @for(chip of mobileTabChips; track chip.id){
        <span
          class="chip"
          #chipEl
          [attr.data-id]="chip.id"
          [class.active]="chip.id === selectedTabName()"
          (click)="onTabClick(chip, true)"
          >{{ chip.label }}</span
          >
        }
      </section>

      @if (isOldUniprotEntry) {
        <section class="notification">
          <notification-msg
            [type]="'warning'"
            [message]="'This AlphaFold model was generated using a prior version of the UniProt sequence.'">
          </notification-msg>
        </section>
      }

      <section class="molstarcontainer">
        @if(selectedTabName() === 'SProteins'){
          <div class="try-2-parent">
            <div [ngClass]="isColorby ? 'plddtcolor-strap' : 'noplddt-strap'">
            </div>
            <div class="frame-parent3">
              <div class="af-q5vsl9-f1-parent">
                <div class="seq-identity-entry">{{afdb_accession}}</div>
                <div class="current-entry">Current entry</div>
              </div>
              <div class="checkboxes-parent">
                <div class="colour-by-plddt">
                  <div class="vf-form__item vf-form__item--checkbox">
                    <input
                      #benign
                      type="checkbox"
                      id="colorby"
                      value="colorby"
                      class="vf-form__checkbox"
                      [checked]="isColorby"
                      (change)=" (!isColorby); setsuperpose_color()"
                      [(ngModel)]="isColorby"
                      />
                    <label for="colorby" class="colorby-label vf-form__label">Colour by pLDDT
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <div class="molstarView">
          <div
            class="mobile-molstar-container"
          ></div>
        </div>
        <div class="mb-paecontainer">
          @if (selectedTabName() === 'Domains' && tedDomainData().length>0) {
            <app-ted-domains
              [tedDomainData]="tedDomainData()"
              [lengthOfProtein]="entryData().sequenceEnd"
              [pdbeMolstar]="pdbeMolstar"
              [selectedDomain]="tedDomainNumberForClickActive()"
              (handleSelectedDomain)="handleSelectedCard($event)"
            ></app-ted-domains>
          }
          @if(selectedTabName() !== 'SProteins'){
            @if (entryData().paeDocUrl) {
              <app-pae-view
                [paeid]="'molstar-paeviewer'"
                [accession]="accession()"
                [paeDocUrl]="entryData().paeDocUrl"
                [imageUrl]="entryData().paeImageUrl"
                [length]="entryData().sequenceEnd"
                [compactChainLabels]="true"
                (selectedRegion)="cmSelectionUpdate($event)"
                [isMobilePae]="false"
          (click)="
            gaService.eventEmitter(
              'pae-click',
              'pae',
              'click',
              accession(),
              undefined
            )
            "
                >
              </app-pae-view>
            }
          }
        </div>
      </section>
    </main>
